/** Agent → My Residual Analysis: MSC's analysis of their residual statement and the deposit they'd receive. */
import React, { useEffect, useState } from 'react';
import { toast } from 'sonner';
import api from '../lib/api';
import { Card, PageHeader, errorText } from '../components/finance/financeUi';
import { DepositReport } from '../components/residualAnalysis/DepositReport';

export default function MyResidualAnalysisPage() {
  const [rows, setRows] = useState(null);
  useEffect(() => { api.request('/me/residual-analyses').then((d) => setRows(d.analyses)).catch((e) => toast.error(errorText(e))); }, []);
  return (
    <div className="space-y-6 pb-24" data-testid="my-residual-analysis-page">
      <PageHeader eyebrow="Residuals" title="Your MSC Deposit" subtitle="MSC priced your residual statement on MSC costs. Revenue − MSC cost = Net residual × your share = Your deposit." />
      {!rows ? <p className="text-sm text-muted-foreground">Loading…</p> : !rows.length
        ? <Card testid="my-ra-empty"><p className="px-5 py-8 text-sm text-muted-foreground">No analysis yet. Send your current residual statement to MSC and your deposit estimate will appear here.</p></Card>
        : rows.map((a) => (
          <Card key={a.analysis_id} title={`Statement ${a.period || ''} · ${new Date(a.finalized_at || a.created_at).toLocaleDateString()}`} testid={`my-ra-${a.analysis_id}`}>
            <div className="px-5 py-4"><DepositReport a={a} /></div>
          </Card>
        ))}
    </div>
  );
}
